import PropTypes from 'prop-types';
import { Heading, ModalDialog, Button } from '@zillow/constellation';
import { RenderMarkdown } from '@zillow/zhl-wordpress-commons';
const TermsModal = ({ onClose, isOpen, terms }) => (
    <ModalDialog
        wide
        isOpen={isOpen}
        onClose={onClose}
        header={<Heading level="4">Sample loan terms</Heading>}
        body={<RenderMarkdown markdown={terms} />}
        footer={
            <Button onClick={onClose} buttonType="primary">
                Close
            </Button>
        }
    />
);
TermsModal.propTypes = {
    onClose: PropTypes.func,
    isOpen: PropTypes.bool,
    terms: PropTypes.string,
};
export default TermsModal;
